<template>
  <section class="section">
    <h1
      class="
        has-text-centered has-text-weight-bold
        subtitle
        is-size-4-mobile is-size-3-desktop
        pdx-small-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Which Quiz Shows are the Most Stressful to Watch?
    </h1>
    <h2
      class="
        has-text-centered
        subtitle
        is-size-6-mobile is-size-4-desktop
        pdx-large-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Quiz Shows can be stressful affairs – even for the audiences at home!
      <br /><br /><strong>The Chase</strong> was found to be the most stressful
      quiz show to watch with <strong>11,855 stressed tweets</strong>...
      probably from those annoyed at the contestants who took the lower offer!
    </h2>

    <chart-tab showType="Quiz"></chart-tab>
  </section>
</template>

<script>
  import ChartTab from "@/components/ChartTab";
  export default {
    components: { ChartTab },
  };
</script>

<style lang="scss" scoped>
  .section {
    background: linear-gradient(#d9edf6, #ffffff);
  }
</style>
